var React = require('react');

function V3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"V3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("polygon",{"points":"33.76 84.27 50.52 42.14 67.28 0 33.64 0.04 0 0.09 16.88 42.18 33.76 84.27","fill":"#73c9bd","style":{"mixBlendMode":"multiply"}}))]);
}

V3.defaultProps = {"viewBox":"0 0 67.28 84.27"};

module.exports = V3;

V3.default = V3;
